import { Modal } from '@bfe/moly';
import { useLocale } from '../../store/i18nMessage';
import { useChainList } from '../../store/chainList';
import { useEffect, useMemo, useState } from 'react';
import updateImg from './images/chain_update_bg.png';
import { scTrack } from '../../utils/scTrack';
import { Chain, web3Navigate } from '@web3/utils';
import { chainNamesStorageKey } from '../../utils/constants';
import { permissionStore } from '../../store/permission';
import { getDefaultIndex } from '../../store/config';
import { isBrowser } from '../../utils/trick';
import { useCurrentWallet } from '../../store/userWallet';

export type ChainUpdateModalProps = {};

export function ChainUpdateModal(_props: ChainUpdateModalProps) {
  const { t, locale } = useLocale();
  const { chainList } = useChainList();

  const [visible, setVisible] = useState(false);
  const { isBrowserWallet } = useCurrentWallet();

  useEffect(() => {
    if (!chainList.length || !isBrowserWallet) {
      return;
    }
    const show = checkChainsUpdate(chainList);
    if (show) {
      setVisible(show);
      scTrack('SpotWeb3NewChainReminderPopUpExposure');
    }
  }, [chainList, isBrowserWallet]);

  const chainIcons = useMemo(() => {
    return [...chainList].sort((a, b) => b.createAt - a.createAt).map((v) => v.iconDayUrl);
  }, [chainList]);

  return (
    <Modal
      zIndex={getDefaultIndex()}
      open={visible}
      modal={false}
      closable={false}
      title={t('new_fun_title')}
      onOk={() => {
        scTrack('SpotWeb3NewChainReminderPopUpClick', { button_name: 'Try' });
        web3Navigate(`/${locale}/web3/balance`);
      }}
      onCancel={() => {
        scTrack('SpotWeb3NewChainReminderPopUpClick', { button_name: 'Close' });
        setVisible(false);
      }}
    >
      <div className="flex flex-col items-center">
        <div
          className="w-[416px] h-[222px] flex items-center justify-center flex-col"
          style={{
            backgroundImage: `url('${updateImg}')`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100% 100%',
          }}
        >
          <div className="flex gap-3">
            {chainIcons.slice(0, 4).map((item) => (
              <img key={item} src={item} alt={item} className="w-10" />
            ))}
          </div>
          <div className="flex mt-4 gap-3">
            {chainIcons.slice(4, 9).map((item) => (
              <img key={item} src={item} alt={item} className="w-10" />
            ))}
          </div>
        </div>
        <p className="mt-6 text-sm break-words text-bds-gray-t2 text-center">
          {t('chain_supported', { chains: chainList.map((v) => v.chainName).join(', ') })}
        </p>
      </div>
    </Modal>
  );
}

const checkChainsUpdate = (chains: Chain[]) => {
  if (!isBrowser) {
    return false;
  }
  // 获取缓存的链
  let oldChains = [];
  if (localStorage.getItem(chainNamesStorageKey)) {
    oldChains = JSON.parse(localStorage.getItem(chainNamesStorageKey) as string);
  }
  // 比对链信息
  const showUpdateDialog = !permissionStore.state.isLawRestricted && Boolean(chains.length > oldChains.length);
  localStorage.setItem(chainNamesStorageKey, JSON.stringify(chains.map((v) => v.chainName)));
  return showUpdateDialog;
};
